var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.911C7 -3.089 11.5 4.911 16 0.911002C10.5 8.411 6.5 0.411002 2.5 2.911Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.411H10",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 20.411H10",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.411H15.5",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.411H15.5",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17.411H21",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.411H21",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.411C0.867392 23.411 0.740215 23.3583 0.646447 23.2646C0.552678 23.1708 0.5 23.0436 0.5 22.911V15.65C0.500173 15.6269 0.501844 15.6039 0.505 15.581L1.877 5.841C1.89387 5.72172 1.95323 5.61254 2.04418 5.53354C2.13512 5.45453 2.25153 5.41102 2.372 5.411H3.926C4.04127 5.41098 4.153 5.45078 4.24229 5.52367C4.33158 5.59656 4.39295 5.69807 4.416 5.811L6.1 13.925C6.11648 14.0047 6.15215 14.0791 6.20392 14.1419C6.25569 14.2046 6.32199 14.2538 6.39706 14.2851C6.47214 14.3165 6.55373 14.329 6.63475 14.3217C6.71577 14.3143 6.79378 14.2873 6.862 14.243L10.727 11.732C10.8025 11.683 10.8898 11.6554 10.9798 11.6519C11.0697 11.6485 11.1589 11.6693 11.2379 11.7123C11.317 11.7553 11.383 11.8189 11.4289 11.8963C11.4749 11.9737 11.4991 12.062 11.499 12.152V13.786C11.499 13.8733 11.5218 13.9591 11.5652 14.0348C11.6086 14.1105 11.6711 14.1736 11.7465 14.2177C11.8218 14.2618 11.9074 14.2854 11.9946 14.2861C12.0819 14.2869 12.1679 14.2648 12.244 14.222L16.772 11.673C16.8481 11.6302 16.9341 11.6081 17.0214 11.6089C17.1086 11.6096 17.1942 11.6332 17.2695 11.6773C17.3449 11.7214 17.4074 11.7845 17.4508 11.8602C17.4942 11.9359 17.517 12.0217 17.517 12.109V13.8C17.5169 13.8877 17.5399 13.9739 17.5837 14.0499C17.6275 14.1259 17.6904 14.1891 17.7663 14.233C17.8422 14.277 17.9283 14.3002 18.016 14.3004C18.1037 14.3006 18.1899 14.2777 18.266 14.234L22.75 11.66C22.826 11.6164 22.9121 11.5935 22.9997 11.5936C23.0873 11.5937 23.1734 11.6169 23.2492 11.6607C23.3251 11.7046 23.3881 11.7676 23.4319 11.8435C23.4758 11.9193 23.4989 12.0054 23.499 12.093V22.911C23.499 23.0436 23.4463 23.1708 23.3526 23.2646C23.2588 23.3583 23.1316 23.411 22.999 23.411H1Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlants);
export default __webpack_public_path__ + "static/media/Plants.9fd98c77.svg";
export { ForwardRef as ReactComponent };